import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './header.css';
import { IoMdPhonePortrait, IoMdClose, IoIosSearch } from "react-icons/io";
import { assets, elementos } from '../../assets/assets';
import { FaKey, FaStamp, FaGift, FaScissors, FaCarBattery, FaPaintbrush, FaKitchenSet, FaGlasses } from "react-icons/fa6";
import { GiComputing, GiDominoTiles, GiCampingTent, GiSatelliteCommunication } from "react-icons/gi";
import { FaTools, FaRing, FaHandsWash, FaBatteryFull, FaClock } from "react-icons/fa";
import { LuCigarette, LuWashingMachine, LuScissorsLineDashed } from "react-icons/lu";
import { CgArrangeBack } from "react-icons/cg";
import { PiPencilRulerFill, PiPintGlassFill } from "react-icons/pi";
import { IoMusicalNotes } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import { GiElectricalSocket } from "react-icons/gi";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // ESTADOS
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const isActive = (path) => location.pathname === path;

  const sobreNos = [
    { nome: 'Quem somos', link: '/quem_somos' },
    { nome: 'Trabalhe conosco', link: '/trabalhe_conosco' },
  ]

  const mercadorias = [
    { nome: 'Aventura', icone: <GiCampingTent />, link: '/produto_aventura' },
    { nome: 'Baterias', icone: <FaCarBattery />, link: '/produto_baterias' },
    { nome: 'Carimbos', icone: <FaStamp />, link: '/produto_carimbos' },
    { nome: 'Celular', icone: <IoMdPhonePortrait />, link: '/produto_celular' },
    { nome: 'Chaves', icone: <FaKey />, link: '/produto_chaves' },
    { nome: 'Cuidados Pessoais', icone: <FaHandsWash />, link: '/produto_cuidados_pessoais' },
    { nome: 'Cutelaria', icone: <FaScissors />, link: '/produto_cutelaria' },
    { nome: 'Decoração', icone: <CgArrangeBack />, link: '/produto_decoracoes' },
    { nome: 'Escritório', icone: <PiPencilRulerFill />, link: '/produto_escritorio' },
    { nome: 'Ferramentas', icone: <FaTools />, link: '/produto_ferramentas' },
    { nome: 'Informática', icone: <GiComputing />, link: '/produto_informatica' },
    { nome: 'Instrumentos Musicais', icone: <IoMusicalNotes />, link: '/produto_instrumentos' },
    { nome: 'Jogos', icone: <GiDominoTiles />, link: '/produto_jogos' },
    { nome: 'Joias', icone: <FaRing />, link: '/produto_joias' },
    { nome: 'Óculos', icone: <FaGlasses />, link: '/produto_oculos' },
    { nome: 'Pilhas', icone: <FaBatteryFull />, link: '/produto_pilhas' },
    { nome: 'Presentes', icone: <FaGift />, link: '/produto_presente' },
    { nome: 'Relógios', icone: <FaClock />, link: '/produto_relogios' },
    { nome: 'Sinal', icone: <GiSatelliteCommunication />, link: '/produto_sinal' },
    { nome: 'Tabacaria', icone: <LuCigarette />, link: '/produto_tabacaria' },
    { nome: 'Tomadas', icone: <GiElectricalSocket />, link: '/produto_tomadas' },
    { nome: 'Utensílios', icone: <FaKitchenSet />, link: '/produto_utensilios' },
  ]

  const servicos = [
    { nome: 'Afiação', icone: <LuScissorsLineDashed />, link: '/servico_afiacao' },
    { nome: 'Carimbos', icone: <FaStamp />, link: '/servico_carimbos' },
    { nome: 'Celulares', icone: <IoMdPhonePortrait />, link: '/servico_celular' },
    { nome: 'Chaves', icone: <FaKey />, link: '/servico_chave' },
    { nome: 'Eletrônicos', icone: <LuWashingMachine />, link: '/servico_eletronicos' },
    { nome: 'Gravação a Laser', icone: <PiPintGlassFill />, link: '/gravacao_laser' },
    { nome: 'Gravação Manual', icone: <FaPaintbrush />, link: '/gravacao_manual' },
    { nome: 'Joias', icone: <FaRing />, link: '/servico_joias' },
    { nome: 'Óculos', icone: <FaGlasses />, link: '/servico_oculos' },
    { nome: 'Relógios', icone: <FaClock />, link: '/servico_relogio' },
  ];

  // LÓGICA DE BUSCA
  const normalizarTexto = (texto) => {
    return texto
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ç/g, "c");
  };

  const retornaRota = (rota) => {
    if (rota === '/trabalhe_conosco') return 'Trabalhe conosco';
    if (rota === '/servico_relogio') return 'Serviços em relógio';
    if (rota === '/servico_joias') return 'Serviços em joias';
    if (rota === '/servico_celular') return 'Serviços em celulares';
    if (rota === '/gravacao_laser') return 'Gravações a laser';
    if (rota === '/servico_carimbos') return 'Serviços em carimbos';
    if (rota === '/gravacao_manual') return 'Gravações manuais';
    if (rota === '/servico_chave') return 'Serviços em chaves';
    if (rota === '/servico_eletronicos') return 'Serviços em eletrônicos';
    if (rota === '/servico_afiacao') return 'Serviços em afiação';
    if (rota === '/servico_oculos') return 'Serviços em óculos';
    if (rota === '/produto_celular') return 'Celulares';
    if (rota === '/produto_baterias') return 'Baterias';
    if (rota === '/produto_aventura') return 'Aventuras';
    if (rota === '/produto_carimbos') return 'Carimbos';
    if (rota === '/produto_chaves') return 'Chaves';
    if (rota === '/produto_informatica') return 'Informática';
    if (rota === '/produto_sinal') return 'Sinal';
    if (rota === '/produto_utensilios') return 'Utensílios';
    if (rota === '/produto_cuidados_pessoais') return 'Cuidados pessoais';
    if (rota === '/produto_cutelaria') return 'Cutelaria';
    if (rota === '/produto_decoracoes') return 'Decorações';
    if (rota === '/produto_ferramentas') return 'Ferramentas';
    if (rota === '/produto_instrumentos') return 'Instrumentos musicais';
    if (rota === '/produto_jogos') return 'Jogos';
    if (rota === '/produto_joias') return 'Joias';
    if (rota === '/produto_oculos') return 'Óculos';
    if (rota === '/produto_escritorio') return 'Escritório';
    if (rota === '/produto_pilhas') return 'Pilhas';
    if (rota === '/produto_presente') return 'Presentes';
    if (rota === '/produto_relogios') return 'Relógios';
    if (rota === '/produto_tomadas') return 'Tomadas';
    if (rota === '/produto_tabacaria') return 'Tabacaria';
    return 'rota';
  }

  const handleSearch = (e) => {
    const value = e.target.value || "";
    setSearchTerm(value);

    if (value.toString().trim().length > 1) {
      const termoNormalizado = normalizarTexto(value);

      const matches = elementos.filter(item => {
        const nomeNormalizado = normalizarTexto(item.nome);
        return nomeNormalizado.includes(termoNormalizado);
      });

      const uniqueResults = matches.filter((v, i, a) =>
        a.findIndex(t => t.rota === v.rota) === i
      );

      setFilteredResults(uniqueResults);
    } else {
      setFilteredResults([]);
    }
  };

  const handleSelectResult = (rota) => {
    navigate(rota);
    setSearchTerm("");
    setFilteredResults([]);
    setIsSearchModalOpen(false);
  };

  const toggleSubmenu = (menuName) => {
    setActiveSubmenu(activeSubmenu === menuName ? null : menuName);
  };

  // Bloquear scroll quando modal aberto
  useEffect(() => {
    if (isSearchModalOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
  }, [isSearchModalOpen]);


  return (<>
    <div className="header-wrapper">
      <header className="header-container">
        <Link to='/'><img className='logo-trinco' src={assets.Logo} alt="" /></Link>

        {/* NAVEGAÇÃO */}
        <nav>
          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link ${isActive('/') ? 'active-link' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)} // Fecha menu mobile se clicar
              >
                Home
              </Link>

            </li>

            {/* Submenu Serviços (10 itens) */}
            {/* Submenu Sobre Nós */}
            <li className={`nav-item ${activeSubmenu === 'sobre' ? 'mobile-active' : ''}`}>
              <span
                className={`nav-link ${isActive('/quem_somos') ? 'active-link' : ''}`}
                onClick={() => toggleSubmenu('sobre')} // Alterna ao clicar
              >
                Sobre nós {activeSubmenu === 'sobre' ? '▴' : '▾'}
              </span>
              <div className="submenu">
                {sobreNos.map((m, idx) => (
                  <Link key={idx} to={m.link} className="submenu-item" onClick={() => setIsMobileMenuOpen(false)}>
                    {m.nome}
                  </Link>
                ))}
              </div>
            </li>

            {/* Submenu Serviços */}
            <li className={`nav-item ${activeSubmenu === 'servicos' ? 'mobile-active' : ''}`}>
              <span
                className="nav-link"
                onClick={() => toggleSubmenu('servicos')}
              >
                Serviços {activeSubmenu === 'servicos' ? '▴' : '▾'}
              </span>
              <div className="submenu grid-servicos">
                {servicos.map((m, idx) => (
                  <Link key={idx} to={m.link} className="submenu-item" onClick={() => setIsMobileMenuOpen(false)}>
                    <span className="item-icon">{m.icone}</span>
                    {m.nome}
                  </Link>
                ))}
              </div>
            </li>

            {/* Submenu Produtos */}
            <li className={`nav-item ${activeSubmenu === 'produtos' ? 'mobile-active' : ''}`}>
              <span
                className="nav-link"
                onClick={() => toggleSubmenu('produtos')}
              >
                Produtos {activeSubmenu === 'produtos' ? '▴' : '▾'}
              </span>
              <div className="submenu grid-mercadorias">
                {mercadorias.map((m, idx) => (
                  <Link key={idx} to={m.link} className="submenu-item" onClick={() => setIsMobileMenuOpen(false)}>
                    <span className="item-icon">{m.icone}</span>
                    {m.nome}
                  </Link>
                ))}
              </div>
            </li>

            <li className="nav-item">
              <a
                href="http://mais.trincoservicos.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Trinco+
              </a>
            </li>
            {/*             <li className="nav-item">
              <Link
                to="/trinco_mais"
                className={`nav-link ${isActive('/trinco_mais') ? 'active-link' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Trinco+
              </Link>

            </li>
            */}
            <li className="nav-item">
              <Link
                to="/nossas_lojas"
                className={`nav-link ${isActive('/nossas_lojas') ? 'active-link' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Lojas
              </Link>

            </li>

            <li className="nav-item">
              <Link
                to="/fale_conosco"
                className={`nav-link ${isActive('/fale_conosco') ? 'active-link' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Fale conosco
              </Link>

            </li>

          </ul>
        </nav>

        {/* BARRA DE PESQUISA (Gatilho Modal) E HAMBÚRGUER */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div className="search-container-trigger" onClick={() => setIsSearchModalOpen(true)}>
            <IoIosSearch className="search-icon-header" />
            <span className="search-text-header">Buscar...</span>
          </div>

          <button className="mobile-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* BUSCA E HAMBÚRGUER 
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <form className="search-container" onSubmit={handleSearch}>
            <span style={{ position: 'absolute', left: '12px', fontSize: '1.3rem' }}><IoIosSearch /></span>
            <input
              type="text"
              className="search-input"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </form>

          <button
            className="mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>*/}
      </header>
    </div>

    {/* MODAL DE BUSCA OVERLAY */}
    {isSearchModalOpen && (
      <div className="search-modal-overlay" onClick={() => setIsSearchModalOpen(false)}>
        <div className="search-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="search-modal-header">
            <IoIosSearch className="modal-search-icon" />
            <input
              autoFocus
              type="text"
              className="modal-search-input"
              placeholder="O que você procura hoje?"
              value={searchTerm}
              onChange={handleSearch}
            />
            <button className="close-modal-btn" onClick={() => setIsSearchModalOpen(false)}>
              <IoMdClose />
            </button>
          </div>

          <div className="search-modal-body">
            {filteredResults.length > 0 ? (
              <div className="search-results-grid">
                {filteredResults.map((result, index) => (
                  <div
                    key={index}
                    className="search-result-card"
                    onClick={() => handleSelectResult(result.rota)}
                  >
                    <div className="result-info">
                      <strong>{result.nome}</strong>
                      <p>Ir para: {retornaRota(result.rota)}</p>
                    </div>
                    {/* Substituímos a interrogação por um ícone de seta real do React Icons */}
                    <div className="result-icon-wrapper">
                      <IoIosArrowForward />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="search-empty-state">
                {searchTerm.length > 1 ? (
                  <p>Sem resultados para "<strong>{searchTerm}</strong>"</p>
                ) : (
                  <p>Digite o que você procura (ex: relógio, chave, joias...)</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    )}

  </>
  );
};

export default Header;